<div
  *ngFor="let additionalSolution of additionalSolutions; let i = index"
  class="udex-mb-24 udex-mb-sm-32"
  [class.pt-4]="i > 0"
>
  <ng-container *ngIf="!headline">
    <ng-container *ngFor="let productOe of additionalSolution.products">
      <h3 *ngIf="productOe?.product" class="heading__medium--xxxxs d-inline">
        {{'checkout.for' | cxTranslate}}&nbsp;{{productOe.product.name}}&nbsp;{{'common.braces' | cxTranslate: {parameter: productOe.product.supplierAlternativeAID} }}
      </h3>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="headline">
    <h3 class="heading__medium--xxxxs d-inline">
      {{headline}}
    </h3>
  </ng-container>
  <ng-container *ngIf="showToolTipContent">
    <ng-container *ngIf="getToolTipContent(additionalSolution.products) | async as toolTipContent">
      <dcp-icon-button-tooltip [placement]="'Bottom'" [openOnClick]="true">
        <span class="body--s">
          {{ toolTipContent }}
        </span>
      </dcp-icon-button-tooltip>
    </ng-container>
  </ng-container>
  <div *ngFor="let derivative of additionalSolution.derivatives">
    <udex-divider [ngClass]="showToolTipContent ? '' : ['udex-mt-8', 'udex-mt-sm-12'] "
      class="d-block udex-mb-8 udex-mb-sm-12 udex-mb-lg-16"></udex-divider>    
    <div
      class="d-sm-flex justify-content-between">
      <p class="body--xs udex-m-0">
        {{derivative.product?.name}}&nbsp;{{'common.braces' | cxTranslate: {parameter: derivative.product?.supplierAlternativeAID} }}
      </p>
      <p class="body--xs text-end udex-mt-8 udex-mt-sm-0">
        {{getDerivativePrice(derivative)}}
      </p>
    </div>
  </div>
</div>
